import { useDispatch, useSelector } from "react-redux";
import PartnerInfo from "../../../components/home/partner";
import { TRootState } from "../../../store";
import SelectDate from "../../../components/ui/select-date";
import { useEffect, useState } from "react";
import moment from "moment";
import { Button, Input, Select2 } from "../../../components/ui";
import useArrivalDetails from "../../../hooks/trade_detail/useArrivalDetails";
import TradeFileUploader from "../../../components/trade-file-uploader/trade_file_upload";
import DragDropUploader from "../../../components/components-library/drag-drop-upload";
import DocumentPreview from "../../../components/commons/document-preview";
import { FaXmark } from "react-icons/fa6";
import {
  setArrivalPmtHistory,
  setOpenArrivalPmtEdit,
} from "../../../reducers/arrivalDetails_slice";
import useAxiosClient from "../../../hooks/useAxiosClient";
import { toast } from "react-toastify";
import CustomDropdown from "../../../components/components-library/dropdown";
import { setRefreshMovePmt } from "../../../reducers/trade_details_Slice";

const paidOptions = [
  { label: "ONO", value: "ONO" },
  { label: "Transporter", value: "TRANSPORTER" },
  { label: "Own Vehicle", value: "OWN_VEHICLE" },
];

const TransportPmtEdit = () => {
  const {
    tradeDetailsById,
    arrival,
    openTransportPmtEdit,
    adminId,
    tradeId,
    traderId,
    arrivalWight,
  } = useSelector((state: TRootState) => ({
    tradeDetailsById: state.tradeDetailsById.tradeDetailsbyId,
    arrival: state.arrivalDetails.arrivalDocs.arrival,
    openTransportPmtEdit: state.arrivalDetails.openTransportPmtEdit,
    adminId: state.auth.adminId,
    tradeId: state.tradeDetails.tradeId,
    traderId: state.tradeDetails?.traderId,
    arrivalWight: state.arrivalDetails.arrivalDocs.arrivalWight,
  }));

  const dispatch = useDispatch();

  const { handlePutCall } = useAxiosClient();

  const [transportationPmt, setTransportationPmt] = useState<{
    paymentDate: string;
    amountReceived: number;
    paymentMode: string;
    comments: string;
    paymentReceiptDate: string;
    utrNumber: string;
    description: string;
  }>({
    paymentDate: moment().format("DD-MM-YYYY"),
    amountReceived: 0,
    paymentMode: "",
    comments: "",
    paymentReceiptDate: moment().format("DD-MM-YYYY"),
    utrNumber: "",
    description: "",
  });

  const [openCalender, setOpenCalendar] = useState(false);

  const handleDateSelection = (_date: string) => {
    let date = moment(_date).format("YYYY-MM-DD");
    setOpenCalendar(false);
    setTransportationPmt({
      ...transportationPmt,
      paymentDate: date,
    });
  };

  const { onUploadReceiptImage1, onRemoveReceiptImage1 } = useArrivalDetails({
    mode: "",
  });

  const handlePaymentReceiptDate = (_date: string) => {
    let date = moment(_date).format("YYYY-MM-DD");
    setOpenCalendar(false);
    setTransportationPmt({
      ...transportationPmt,
      paymentReceiptDate: date,
    });
  };

  const [selectPaidTo, setSelectedPaidTo] = useState("");

  const handleChangePaidTo = (value: any) => {
    setSelectedPaidTo(value);
  };

  const savePaymentReceipt = () => {
    if (transportationPmt?.utrNumber === "") {
      toast.error("Please enter UTR number");
      return;
    }
    let imgs: Array<{
      id: number;
      imgFrom: string;
      reqId: number;
      status: number;
      addedBy: number;
      type:
      | "TAPAL_INVOICE"
      | "WEIGH_BRIDGE"
      | "OTHER"
      | "TRANSPORT_PAYMENT"
      | "PATTI"
      | "PAYMENT"
      | "ARRIVAL_WEIGHT_BRIDGE";
      url: string;
    }> = [];
    let arrivalImages = imgs;
    if (arrival.length > 0) {
      for (let file of arrival) {
        arrivalImages.push({
          id: 0,
          imgFrom: "DEST_TRADER",
          reqId: tradeDetailsById?.tradeId!,
          status: 1,
          addedBy: traderId || 0,
          type: "TRANSPORT_PAYMENT",
          url: file.url,
        });
      }
    } else {
      if (tradeDetailsById != null) {
        if (tradeDetailsById?.arrivalDocs.length > 0) {
          for (let file of tradeDetailsById?.arrivalDocs) {
            if (file.status == 0) {
              arrivalImages.push({
                ...file,
                addedBy: traderId,
              });
            }
          }
        }
      }
    }
    if (arrivalWight.length > 0) {
      for (let file of arrivalWight) {
        arrivalImages.push({
          id: 0,
          imgFrom: "DEST_TRADER",
          reqId: tradeDetailsById?.tradeId!,
          status: 1,
          addedBy: traderId || 0,
          type: "ARRIVAL_WEIGHT_BRIDGE",
          url: file.url,
        });
      }
    } else {
      if (tradeDetailsById != null) {
        if (tradeDetailsById?.arrivalWeightDocs.length > 0) {
          for (let file of tradeDetailsById?.arrivalWeightDocs) {
            if (file.status == 0) {
              arrivalImages.push({
                ...file,
                addedBy: traderId,
              });
            }
          }
        }
      }
    }

    handlePutCall({
      URL: "admin/trade-platform/freight",
      apiParams: {
        adminId: adminId,
        comments: transportationPmt?.comments,
        date: moment(transportationPmt?.paymentDate).format("YYYY-MM-DD"),
        descr: transportationPmt?.description,
        freightPaid: transportationPmt?.amountReceived,
        images: imgs,
        paidTo: selectPaidTo,
        pmtDate: moment(transportationPmt?.paymentReceiptDate).format(
          "YYYY-MM-DD"
        ),
        pmtMode: transportationPmt?.paymentMode,
        pmtStatus: "ACCEPTED",
        tradeId: tradeId,
        utr: transportationPmt?.utrNumber,
      },
    }).then(({ data }) => {
      toast.success("Updated successfully");
      dispatch(setOpenArrivalPmtEdit(false));
      dispatch(setArrivalPmtHistory(false));
      dispatch(setRefreshMovePmt(true));
    });
  };

  const transportationAmounts = tradeDetailsById?.destPmtHistory
    ?.filter((doc: any) => doc.pmtStatus !== "CANCELLED" && doc.pmtType === "TRANSPORTATION")
    ?.map((doc: any) => doc.amount);

  useEffect(() => {
    if (openTransportPmtEdit) {
      setTransportationPmt({
        ...transportationPmt,
        paymentDate: tradeDetailsById?.freightDtls?.date
          ? moment(tradeDetailsById?.freightDtls?.date).format("DD-MMM-YYYY")
          : moment().format("DD-MMM-YYYY"),
        amountReceived: tradeDetailsById?.freightDtls?.paidTo === 'ONO' ?
          Number(transportationAmounts) :
          Number(tradeDetailsById?.freightDtls?.freightPaid),
        paymentMode: tradeDetailsById?.freightDtls?.pmtMode
          ? tradeDetailsById?.freightDtls?.pmtMode
          : "",
        comments: tradeDetailsById?.freightDtls?.comments ?? "",
        paymentReceiptDate: tradeDetailsById?.freightDtls?.pmtDate
          ? moment(tradeDetailsById?.freightDtls?.pmtDate).format("DD-MMM-YYYY")
          : moment().format("DD-MMM-YYYY"),
        utrNumber: tradeDetailsById?.freightDtls?.utr ?? "",
        description: tradeDetailsById?.freightDtls?.descr ?? "",
      });
      setSelectedPaidTo(tradeDetailsById?.freightDtls?.paidTo ?? "");
    }
  }, []);

  return (
    <>
      <div
        className="card_space_18 overflow-y-auto"
        style={{ height: "calc(100vh - 10rem)" }}
      >
        <div className="flex flex-col gap-y-2">
          <div className="border flex flex-col rounded-lg p-3 bg-white">
            <PartnerInfo
              partyType="From"
              name={tradeDetailsById?.freightDtls?.destDriverName || ""}
              tradeName={tradeDetailsById?.destTradeName + "(Dest)" || ""}
              profilePic={""}
            />
          </div>
        </div>

        <div className="w-[100%] flex gap-4 space_18">
          <div className={"w-[50%]"}>
            <span className="font-semibold fs-14">Payment Date</span>
            <SelectDate
              onChange={handleDateSelection}
              selectedDate={transportationPmt?.paymentDate}
            />
          </div>

          <div className={"w-[50%]"}>
            <CustomDropdown
              label="Paid To"
              options={paidOptions}
              value={selectPaidTo}
              onChange={handleChangePaidTo}
              placeholder=""
              className="flex-1"
              required={true}
            />
          </div>
        </div>

        <div className="space_18">
          <div>
            <Input
              type="number"
              label="Amount Received"
              value={transportationPmt?.amountReceived}
              onChange={(e) => {
                setTransportationPmt({
                  ...transportationPmt,
                  amountReceived: parseFloat(e.target.value),
                });
              }}
              className="w-[100%]"
            />
          </div>
        </div>

        <div className="w-[100%] flex gap-4 space_18">
          <div className={"w-[50%]"}>
            <Input
              label="Payment Type"
              disabled={true}
              type=""
              value={"Transportation"}
              className="fs-12 pt-[6px]"
            />
          </div>
          <div className="w-[50%]">
            <Select2
              value={transportationPmt?.paymentMode}
              lable="Payment Mode "
              paymentMargin={true}
              options={[
                {
                  label: "IMPS",
                  value: "IMPS",
                },
                {
                  label: "NEFT",
                  value: "NEFT",
                },
                {
                  label: "UPI",
                  value: "UPI",
                },
                {
                  label: "RTGS",
                  value: "RTGS",
                },
                {
                  label: "CASH",
                  value: "CASH",
                },
                {
                  label: "CHEQUE",
                  value: "CHEQUE",
                },
              ]}
              onChange={(selectedPaymentMode: any) => {
                setTransportationPmt({
                  ...transportationPmt,
                  paymentMode: selectedPaymentMode.value,
                });
              }}
              classNames=""
            />
          </div>
        </div>

        <div className="w-[100%] flex gap-4 space_18">
          <Input
            label="Comments"
            type=""
            value={transportationPmt?.comments}
            onChange={(e) => {
              setTransportationPmt({
                ...transportationPmt,
                comments: e.target.value,
              });
            }}
            className="w-full"
          />
        </div>

        <div className="w-95%] px-[18px] py-[18px] border-gray bg-white rounded-lg space_18">
          <div className="flex-1 pr-4 w-100">
            <div className="flex justify-between items-center pb-2">
              <label className="fs-14">Upload Document </label>
              {tradeDetailsById?.tradeStatus !== "CLOSED" && (
                <TradeFileUploader
                  onChange={(e: any) => {
                    if (e.target.files && e.target.files.length > 0) {
                      onUploadReceiptImage1(
                        "TRANSPORT_PAYMENT",
                        e.target.files
                      );
                    }
                  }}
                  id="arrival"
                />
              )}
            </div>
            <div className="flex gap-4">
              {arrival.length === 0 &&
                (!tradeDetailsById?.arrivalDocs ||
                  tradeDetailsById.arrivalDocs.filter((img) => img.status === 1)
                    .length === 0) && (
                  <DragDropUploader
                    onDrop={(acceptedFiles: any) => {
                      if (acceptedFiles.length > 0) {
                        onUploadReceiptImage1(
                          "TRANSPORT_PAYMENT",
                          acceptedFiles
                        );
                      }
                    }}
                  />
                )}
              <div className="flex gap-4 overflow-x-auto w-[100%] max-h-28">
                {arrival.length > 0 &&
                  arrival.map((image, i) => (
                    <div
                      className="shrink-0 overflow-hidden border doc_card br-10 relative"
                      key={`arival-doc-${i}`}
                    >
                      <a href={image.url} target="_blank">
                        <DocumentPreview
                          url={image.url}
                          docType={image.docType}
                        />
                      </a>
                      <span
                        className="absolute right-0 top-0 p-1 rounded-full cursor-pointer"
                        style={{
                          background: "#ff0000de",
                        }}
                        onClick={() => {
                          onRemoveReceiptImage1("TRANSPORT_PAYMENT", i);
                        }}
                      >
                        <FaXmark style={{ color: "white" }} />
                      </span>
                    </div>
                  ))}
                {tradeDetailsById?.arrivalDocs &&
                  tradeDetailsById?.arrivalDocs
                    .filter((img) => img.status == 1)
                    .map((image, i) => (
                      <div
                        className="shrink-0 overflow-hidden border doc_card br-10 relative"
                        key={`receipt-doc-${i}`}
                      >
                        <a href={image.url} target="_blank">
                          <DocumentPreview
                            url={image.url}
                            docType={image.docType}
                          />
                        </a>
                        <span
                          className="absolute right-0 top-0 p-1 rounded-full cursor-pointer"
                          style={{
                            background: "#ff0000de",
                          }}
                          onClick={() => {
                            onRemoveReceiptImage1(
                              "TRANSPORT_PAYMENT",
                              image.id,
                              true
                            );
                          }}
                        >
                          <FaXmark style={{ color: "white" }} />
                        </span>
                      </div>
                    ))}
              </div>
            </div>
          </div>
        </div>

        <div className="border rounded-lg space_18">
          <div
            className={`p-3 fs-14 rounded-t-lg`}
            style={{
              background: "#EBFFF0",
            }}
          >
            Confirm Receipt
          </div>
          <div className="px-4 py-2 bg-white w-full rounded-b-lg">
            {" "}
            <div className="flex py-3 gap-4">
              <div className="w-[50%]">
                <span className="font-semibold fs-14">
                  Payment Receipt Date<span className="color-red">*</span>
                </span>
                <SelectDate
                  onChange={handlePaymentReceiptDate}
                  selectedDate={transportationPmt?.paymentReceiptDate}
                />
              </div>

              <div className="w-[50%]">
                <Input
                  type="text"
                  required={true}
                  label={"UTR Number"}
                  value={transportationPmt?.utrNumber}
                  onChange={(e) => {
                    setTransportationPmt({
                      ...transportationPmt,
                      utrNumber: e.target.value,
                    });
                  }}
                  inputStyle={{ marginTop: "10px" }}
                />
              </div>
            </div>
            <div className="flex py-3 flex-col">
              <span className="fs-14">Description </span>
              <Input
                value={transportationPmt?.description}
                onChange={(e) => {
                  setTransportationPmt({
                    ...transportationPmt,
                    description: e.target.value,
                  });
                }}
                className="w-[100%]"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white flex absolute bottom-0 justify-between items-center gap-10 px-6 py-4 w-full border-t">
        <Button
          variant="gray"
          onClick={() => {
            dispatch(setOpenArrivalPmtEdit(false));
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={() => {
            savePaymentReceipt();
          }}
        >
          Submit
        </Button>
      </div>
    </>
  );
};
export default TransportPmtEdit;
